/**
 * Get Project Query
 * 
 * Query for retrieving project information for read operations.
 */

import { IQuery, BaseQuery, IPaginatedResult } from '@swoft/core';

export interface ProjectDto {
  id: string;
  name: string;
  description?: string;
  domainId: string;
  boundedContextId?: string;
  metadata: Record<string, any>;
  createdAt: Date;
  updatedAt: Date;
}

export class GetProjectQuery extends BaseQuery<ProjectDto> {
  constructor(
    public readonly projectId: string,
    authSessionId: string,
    initiatedByPersonId: string,
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}

export interface ListProjectsParams {
  page?: number;
  pageSize?: number;
  searchTerm?: string;
  domainId?: string;
  boundedContextId?: string;
}

export class ListProjectsQuery extends BaseQuery<IPaginatedResult<ProjectDto>> {
  constructor(
    public readonly params: ListProjectsParams,
    authSessionId: string = 'system',
    initiatedByPersonId: string = 'system',
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}